import { IconDeliveryList } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

/* ------------------------------------------------------------------ *
 * La lista de entregas — the day's delivery sheet. Logistics plans
 * the routes; this screen is the flat, printable answer to "what
 * leaves the dock today, in what order, and how did it go". It is
 * the page a dispatcher keeps open all morning.
 * ------------------------------------------------------------------ */

export const deliveriesModule: ModuleDefinition = {
  id: 'deliveries',
  i18nNamespace: 'deliveries',
  requires: { subject: 'shipment', action: 'read' },

  nav: {
    labelKey: 'deliveries:nav',
    icon: IconDeliveryList,
    to: 'deliveries',
    group: 'move',
    order: 25,
  },

  routes: [{ path: 'deliveries', component: () => import('./DeliveriesPage') }],

  commands: [
    {
      id: 'deliveries.open',
      labelKey: 'deliveries:title',
      groupKey: 'deliveries:title',
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/deliveries`),
    },
  ],
};
